import bs58 from 'bs58';

export function decodeId(id: string, short: boolean = false): Uint8Array {
  return short ? decodeShortId(id) : decodeLongId(id);
}

/**
 * Parse a hyphenated UUID string into 16 bytes WITHOUT validating the RFC
 * version/variant bits — the mirror of `bytesToUuid` in lengthenId. Postgres
 * `uuid` columns (and Laravel's `uuid` rule) accept any 128-bit value, so ids
 * whose version/variant nibbles aren't RFC-compliant are still legitimate.
 * `uuid`'s `parse` rejects those, which made `shortenId` silently return the
 * long id unchanged and broke round-tripping (so hydration lookups missed).
 */
export function decodeLongId(id: string): Uint8Array {
  const hex = id.replace(/-/g, '');
  if (hex.length !== 32 || /[^0-9a-f]/i.test(hex)) {
    throw new Error(`Invalid UUID: ${id}`);
  }
  const bytes = new Uint8Array(16);
  for (let i = 0; i < 16; i++) {
    bytes[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
  }
  return bytes;
}

export function decodeShortId(id: string): Uint8Array {
  return bs58.decode(id);
}
